import { useCallback, useState } from 'react';
import { AppError } from '../../../types/appError';

export const useAppErrorList = (): [
  { errors: AppError[], hasErrors: boolean },
  {
    addError: (error: AppError) => void,
    setErrors: (errors: AppError[]) => void
    removeError: (index: number) => void,
  },
] => {
  const [appErrors, setAppErrors] = useState<AppError[]>([]);

  const hasErrors = appErrors.length > 0;

  const addError = useCallback((error: AppError) => {
    setAppErrors(currentErrors => [...currentErrors, error]);
  }, [setAppErrors]);

  const setErrors = useCallback((errors: AppError[]) => {
    setAppErrors(errors);
  }, [setAppErrors]);

  const removeError = useCallback((index: number) => {
    setAppErrors(currentErrors => currentErrors.filter((err, idx) => idx !== index));
  }, [setAppErrors]);

  return [
    { errors: appErrors, hasErrors },
    { addError, setErrors, removeError },
  ]
};
